import { put, call, takeLatest, select } from 'redux-saga/effects';

import { fetchContentMetrics } from 'services/analytics';
import { analyticContentMetricsActions } from 'store/actions';
import { IAnalyticContentMetricsMeta } from 'store/actions/analytics/contentMetrics';
import { AsyncAction } from 'types/Action';
import { GenericResponse } from 'types/GenericResponse';
import { Store } from 'types/store/Store';

function* getContentMetrics(
  action: AsyncAction<IAnalyticContentMetricsMeta, GenericResponse>,
): any {
  const state: Store = yield select();
  if (state.auth.token) {
    try {
      const { data } = yield call(
        fetchContentMetrics,
        action.meta,
        state.auth.token,
      );
      yield put(analyticContentMetricsActions.success(data));
    } catch (e: any) {
      yield put(analyticContentMetricsActions.failed(e.message));
    }
  }
}

function* analyticWatcher(): any {
  yield takeLatest(analyticContentMetricsActions.REQUEST, getContentMetrics);
}

export default analyticWatcher;
